import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BrandingLogo, BrandingLogoSizes } from '../BrandingLogo';
import './BrandingLogos.scss';

export const BrandingLogos = ({
    className,
    imgClassName,
    returnUrl,
    logoSize = BrandingLogoSizes.XSmall,
    onLoad,
}) => {
    return (
        <div className={classNames('navigation__branding', className)}>
            <BrandingLogo
                size={logoSize}
                className={classNames('navigation__branding-image', imgClassName)}
                returnUrl={returnUrl}
                onLoad={onLoad}
            />
        </div>
    );
};

BrandingLogos.propTypes = {
    className: PropTypes.string,
    logoSize: PropTypes.oneOf(Object.values(BrandingLogoSizes)),
    onLoad: PropTypes.func,
};
